import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaTimes,
  FaMapMarkerAlt,
  FaBus,
  FaClock,
  FaRoad,
  FaArrowRight,
  FaSun,
  FaMoon,
} from "react-icons/fa";
import "./RouteModal.css";

const RouteModal = ({ route, onClose }) => {
  /* Lock body scroll when modal is open */
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  /* Close on ESC key */
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  /* Auto-generate badge */
  const badge = route.routeName
    .split("→")
    .map((part) => part.trim().slice(0, 3).toUpperCase())
    .join("-");

  /* Evening schedule = reversed route points */
  const eveningSchedule = [...route.routePoints].reverse();

  return (
    <div className="staffline-route-modal-overlay" onClick={onClose}>
      <div
        className="staffline-route-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ===== HEADER ===== */}
        <div className="staffline-route-modal-header">
          <div>
            <span className="staffline-route-modal-badge">{badge}</span>
            <h2 className="staffline-route-modal-title">{route.routeName}</h2>
          </div>
          <button
            className="staffline-route-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <FaTimes />
          </button>
        </div>

        {/* ===== QUICK STATS ===== */}
        <div className="staffline-route-modal-stats">
          <div className="staffline-route-modal-stat">
            <FaClock />
            <div>
              <strong>{route.routeDuration}</strong>
              <span>Duration</span>
            </div>
          </div>
          <div className="staffline-route-modal-stat">
            <FaRoad />
            <div>
              <strong>{route.routeDistance}</strong>
              <span>Distance</span>
            </div>
          </div>
          <div className="staffline-route-modal-stat staffline-route-modal-stat-price">
            <div>
              <strong>{route.routePrice} GHS</strong>
              <span>Per Month</span>
            </div>
          </div>
        </div>

        {/* ===== MORNING SCHEDULE ===== */}
        <div className="staffline-route-modal-section">
          <div className="staffline-route-modal-section-header">
            <FaSun className="staffline-route-modal-section-icon staffline-route-modal-section-icon-sun" />
            <h3>Morning Schedule</h3>
            <span className="staffline-route-modal-section-sub">
              Pickup → Workplace
            </span>
          </div>

          <ol className="staffline-route-modal-timeline">
            {route.routePoints.map((point, i) => (
              <li key={i} className="staffline-route-modal-timeline-item">
                <div className="staffline-route-modal-timeline-dot"></div>
                <div className="staffline-route-modal-timeline-content">
                  <div className="staffline-route-modal-timeline-name">
                    <FaMapMarkerAlt /> {point.name}
                  </div>
                  <div className="staffline-route-modal-timeline-time">
                    {point.time}
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>

        {/* ===== EVENING SCHEDULE ===== */}
        <div className="staffline-route-modal-section">
          <div className="staffline-route-modal-section-header">
            <FaMoon className="staffline-route-modal-section-icon staffline-route-modal-section-icon-moon" />
            <h3>Evening Return</h3>
            <span className="staffline-route-modal-section-sub">
              Workplace → Same Stops
            </span>
          </div>

          <ol className="staffline-route-modal-timeline staffline-route-modal-timeline-evening">
            {eveningSchedule.map((point, i) => (
              <li key={i} className="staffline-route-modal-timeline-item">
                <div className="staffline-route-modal-timeline-dot"></div>
                <div className="staffline-route-modal-timeline-content">
                  <div className="staffline-route-modal-timeline-name">
                    <FaBus /> {point.name}
                  </div>
                  <div className="staffline-route-modal-timeline-time">
                    {i === 0 ? "5:30 PM (Pickup)" : "Evening Drop-off"}
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>

        {/* ===== ACTIONS ===== */}
        <div className="staffline-route-modal-actions">
          <Link
            to="/subscription"
            className="staffline-route-modal-btn-primary"
          >
            Subscribe to This Route <FaArrowRight />
          </Link>
          <button
            className="staffline-route-modal-btn-secondary"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RouteModal;